import React, { Fragment } from "react"
import { Link } from "react-router-dom"

const CallToAction = ({ url, action, text, buttonText, horizontalRule }) => {
  return (
    <Fragment>
      {horizontalRule && <hr />}
      {text && <p>{text}</p>}
      {action && !url && (
        <span
          className="btn dark-fill small-caps rounded-square restricted__link"
          onClick={() => action()}
        >
          {buttonText}
        </span>
      )}

      {!action && url && (
        <Link
          className="btn dark-fill small-caps rounded-square restricted__link"
          to={url}
        >
          {buttonText}
        </Link>
      )}
    </Fragment>
  )
}

export default CallToAction
